import { Trans, useTranslation } from "react-i18next";

import { getSegmentChangeVariant } from "../changeVariant";

import {
  HistoryEntryCard,
  type EntityHistoryEntry,
} from "@/components/ui/v2/history";

interface VacanciesRemovedChanges {
  vacancyIds?: number[];
}

export function VacanciesRemovedHistoryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  const { t } = useTranslation();
  const changes = entry.changes as VacanciesRemovedChanges | undefined;
  const count = changes?.vacancyIds?.length ?? 0;
  const actor = t("history.actor.system");
  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <Trans
          i18nKey="history.line1.vacanciesRemoved"
          values={{ actor }}
          components={{ b: <strong className="font-semibold" /> }}
        />
      }
      count={t("history.count.vacancies", { count })}
      variant={getSegmentChangeVariant(entry.changeType)}
    />
  );
}
